import { useAuth } from '@/context/auth.context';
import { useClientFeatureControls } from '@/context/client-feature-controls.context';
import {
    useReviewsPageDataContext,
    useReviewsPageProgressContext,
    useReviewsPageQueryContext,
    useReviewsPageSelectionContext,
    useReviewsPageTransportContext,
} from '@/context/reviews-page.context';
import { useSocketIo } from '@/context/socket-io.context';
import { useReviewAnswerJobs } from '@/context/review-answer-jobs.context';

export const useActionButtonsControllerContext = () => {
    const query = useReviewsPageQueryContext();
    const selection = useReviewsPageSelectionContext();
    const data = useReviewsPageDataContext();
    const progress = useReviewsPageProgressContext();
    const transport = useReviewsPageTransportContext();
    const { accessToken } = useAuth();
    const { aiQuota, featureAvailability, featureControls } = useClientFeatureControls();
    const { events, isConnected: isSocketConnected } = useSocketIo();
    const reviewAnswerJobs = useReviewAnswerJobs();

    return {
        query,
        selection,
        data,
        progress,
        transport,
        reviewAnswerJobs,
        featureControls,
        aiQuota,
        featureAvailability,
        accessToken,
        events,
        isSocketConnected,
    };
};
